import script from "./InformeAutoevaluacionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./InformeAutoevaluacionView.vue?vue&type=script&setup=true&lang=ts"

import "./InformeAutoevaluacionView.vue?vue&type=style&index=0&id=2f785f24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f785f24"]])

export default __exports__